<template>
  <div class="doc-income-forecast">
    <doc-table-card :can-edit="canEdit" :layout="item" @on-add="onAdd" @on-edit="onEdit" @del-item="onDel" @on-card-edit="onCardEdit" v-for="(item,index) in layout" :key="index">
    </doc-table-card>

    <a-modal ref="paymentModal" :title="isEdit ? '编辑期款' : '新增期款'" v-model="isVisiblePayment" @ok="onAddPayment" @cancel="onCancel" okText="保存" :width="570" :confirmLoading="submitLoading">
      <a-form class="doc-table-add-form" :form="form">
        <a-form-item v-bind="formItemLayout" label="期数">
          <a-select placeholder="请选择期数" v-decorator="[
              'period',
              {
                initialValue:editData.period?editData.period:'',
                rules: [{required: true, message: '请选择期数'}]
              }
            ]" allowClear>
            <a-select-option v-for="option in periodList" :key="option" :value="option">{{option}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="合同约定开票日期">
          <a-input placeholder="请输入日期" v-decorator="[
              'contract_appointment_bill_date',
              {
                initialValue:editData.contract_appointment_bill_date?editData.contract_appointment_bill_date:'',
                rules: [{required: false, message: '请输入日期'}]
              }
            ]" @change="setFieldsValue">
            <a-icon slot="suffixIcon" :component="'SvgIcDate'"></a-icon>
          </a-input>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="合同约定开票金额">
          <a-input-number placeholder="请输入" v-decorator="[
              'contract_appointment_bill_price',
              {
                initialValue:editData.contract_appointment_bill_price?editData.contract_appointment_bill_price:'',
                rules: [{required: required1, type: 'number', message: '请输入合同约定开票金额'}]
              }
            ]"></a-input-number>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="项目预计开票日期">
          <a-date-picker placeholder="请选择日期" @change="setFieldsValue1" v-decorator="[
              'project_estimate_bill_date',
              {
                initialValue:editData.project_estimate_bill_date?moment(editData.project_estimate_bill_date):undefined,
                rules: [{required: false, message: '请选择日期'}]
              }
            ]">
            <a-icon slot="suffixIcon" :component="'SvgIcDate'"></a-icon>
          </a-date-picker>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="项目预计开票金额">
          <a-input-number placeholder="请输入" v-decorator="[
              'project_estimate_bill_price',
              {
                initialValue:editData.project_estimate_bill_price?editData.project_estimate_bill_price:'',
                rules: [{required: required2, type: 'number', message: '请输入项目预计开票金额'}]
              }
            ]"></a-input-number>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="实际开票日期">
          <a-date-picker placeholder="请选择日期" @change="setFieldsValue2" v-decorator="[
              'actual_bill_date',
              {
                initialValue:editData.actual_bill_date?moment(editData.actual_bill_date):undefined,
                rules: [{required: false, message: '请选择日期'}]
              }
            ]">
            <a-icon slot="suffixIcon" :component="'SvgIcDate'"></a-icon>
          </a-date-picker>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="实际开票金额">
          <a-input-number placeholder="请输入" v-decorator="[
              'actual_bill_price',
              {
                initialValue:editData.actual_bill_price?editData.actual_bill_price:'',
                rules: [{required: required3, type: 'number', message: '请输入实际开票金额'}]
              }
            ]"></a-input-number>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="逾期天数">{{overdue_days ? overdue_days: ''}} (自动计算)</a-form-item>

        <a-form-item v-bind="formItemLayout" label="期款情况备注">
          <a-textarea placeholder="请输入" v-decorator="[
              'payment_remark',
              {
                initialValue:editData.payment_remark?editData.payment_remark:'',
                rules: [{required: false, message: '请输入期款情况备注'}]
              }
            ]"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal :title="isEdit ? '编辑预测' : '新增预测'" v-model="isVisibleForecast" okText="保存" ref="forecastModal" @cancel="onCancel" @ok="onAddForecast" :width="570" :confirmLoading="submitLoading">
      <a-form class="doc-table-add-form" :form="formForecast">
        <a-form-item v-bind="formItemLayout" label="期款ID">
          <a-select placeholder="请选择期款ID" v-decorator="[
              'payment_index',
              {
                initialValue:editData.payment_index?editData.payment_index:undefined,
                rules: [{required: false, message: '请选择期款ID'}]
              }
            ]" @change="setSelectValue" :loading="optionLoading" allowClear>
            <a-select-option v-for="option in paymentNoList" :key="option.key" :value="option.key">{{option.val}}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="未开票预测日期">
          <a-date-picker placeholder="请选择日期" v-decorator="['contract_estimate_income_date',
          {
            initialValue:editData.contract_estimate_income_date?moment(editData.contract_estimate_income_date):undefined,
            rules: [{required: true, message: '请选择未开票预测日期'}]
            }
          ]">
            <a-icon slot="suffixIcon" :component="'SvgIcDate'" />
          </a-date-picker>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="未开票预测金额（含税）">
          <a-input-number placeholder="请输入" v-decorator="[
              'contract_estimate_income_price',
              {
                initialValue:editData.contract_estimate_income_price?editData.contract_estimate_income_price:undefined,
                rules: [{required: true, type: 'number', message: '请输入未开票预测金额（含税）'}]
              }
            ]">
          </a-input-number>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="未开票预测备注">
          <a-textarea placeholder="请输入" v-decorator="[
              'income_remark',
              {initialValue:editData.income_remark?editData.income_remark:undefined,}
            ]" :autoSize="{ minRows: 2, maxRows: 2 }">
          </a-textarea>
        </a-form-item>

      </a-form>
    </a-modal>
    <footer-btn v-if="basicInfo.curr_step_num<stepInfo.stepNum && canEdit" :btnText="btnText" @on-save="onSave" :noCancelBtn="true"></footer-btn>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import SvgIcDate from '../../assets/svg/ic-date-o.svg';

import {
  getContractPayment,
  addOrUpdContractPayment,
  getContractIncomeList,
  addOrUpdContractIncome,
  incomeDelete,
  paymentDelete,
  getPeriodList,
} from '../../services/DocService.js';
import { amountToNumber } from '../../utils/tools.js';

export default {
  name: 'docIncomeForecast',
  props: {
    basicInfo: Object,
    canEdit: Boolean,
    stepInfo: Object
  },
  components: {
    SvgIcDate
  },
  mounted() {
    this.queryPayment();
    this.queryIncome();

    if (this.nextStepName) {
      this.btnText.okText = `填写${this.stepInfo.nextStepName} →`;
    }
  },
  methods: {
    moment,
    onDel(e) {
      this.$Modal.confirm({
        width: 480,
        title: '是否确认删除本条记录？',
        okText: '确认',
        onOk: () => {
          if (e.cardTitle === '期款情况') {
            return paymentDelete({ id: e.record.id }).then((res) => {
              if (res.status === 'success') {
                this.queryPayment();
                // this.$Message.success('期款序号可能有变更，请关注并及时核对未开票预测、回款金额关联的期款序号');
                this.$emit('update-doc');
              } else {
                this.$Message.error(res.message);
              }
            });
          }

          return incomeDelete({ id: e.record.id }).then((res) => {
            if (res.status === 'success') {
              this.queryIncome();
              this.$emit('update-doc');
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    queryPayment() {
      const params = {
        contract_sn: this.basicInfo.contract_sn
      };
      this.layout[0].loading = true;
      return getContractPayment(params).then((res) => {
        if (res.status === 'success' && res.data.payment_data) {
          res.data.payment_data.forEach((item, index) => {
            item.key = index + 1;
            item.Overdue_days = this.getOverdueDays(
              item.project_estimate_bill_date,
              item.actual_bill_date
            );
          });
          res.data.payment_data.push({
            key: '合计',
            contract_appointment_bill_price: res.data.total_contract_amount,
            project_estimate_bill_price: res.data.total_project_amount,
            actual_bill_price: res.data.total_actual_amount
          });
          const cardData = this.layout[0];
          cardData.tableData = res.data.payment_data;
        } else if (res.status === 'failed') {
          this.$Message.error(res.message);
        }
        this.layout[0].loading = false;
      });
    },
    addPayment(params) {
      this.submitLoading = true;
      return addOrUpdContractPayment(params).then((res) => {
        if (res.status === 'success') {
          this.isVisiblePayment = false;
          this.step_num = this.stepInfo.stepNum;
          this.queryPayment();
          this.queryIncome();
          this.$emit('update-doc');
          // this.$Message.success('期款序号可能有变更，请关注并及时核对未开票预测、回款金额关联的期款序号');
          this.form.resetFields();
          this.onCancel();
        } else {
          this.$Message.error(res.message);
        }
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    queryIncome() {
      const params = {
        contract_sn: this.basicInfo.contract_sn
      };
      this.layout[1].loading = true;
      return getContractIncomeList(params).then((res) => {
        if (res.status === 'success') {
          res.data.income_data.forEach((item, index) => {
            item.key = index + 1;
          });
          const cardData = this.layout[1];
          cardData.tableData = res.data.income_data;
          cardData.statisticalList[0].val = res.data.no_invoice_price;
          cardData.statisticalList[1].val = res.data.sum_estimate_income;
          if (
            cardData.statisticalList[0].val !== cardData.statisticalList[1].val
          ) {
            cardData.statisticalList[1].isHighLight = true;
          } else {
            cardData.statisticalList[1].isHighLight = false;
          }
        } else if (res.status === 'failed') {
          this.$Message.error(res.message);
        }
        this.layout[1].loading = false;
      });
    },
    addIncome(params) {
      this.submitLoading = true;
      return addOrUpdContractIncome(params).then((res) => {
        if (res.status === 'success') {
          this.isVisibleForecast = false;
          this.queryIncome();
          this.step_num = this.stepInfo.nextStepNum;
          this.onCancel();
          this.$emit('update-doc');
        } else {
          this.$Message.error(res.message);
        }
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    onCardEdit(e) {
      this.isVisibleForecast = true;
    },
    onAdd(e) {
      this.isEdit = false;
      if (e === '未开票预测') {
        this.getPaymentNoList();
        this.isVisibleForecast = true;
      } else if (e === '期款情况') {
        this.isVisiblePayment = true;
      }
    },
    onCancel() {
      this.required1 = false;
      this.required2 = false;
      this.required3 = false;
      this.editData = {};
      this.form.resetFields();
      this.formForecast.resetFields();
      this.formCache.project_estimate_bill_date = undefined;
      this.formCache.actual_bill_date = undefined;
    },
    onEdit(e) {
      this.isEdit = true;
      if (e.cardTitle === '期款情况') {
        const fields = _.cloneDeep(e.record);
        if (fields.contract_appointment_bill_price) {
          fields.contract_appointment_bill_price = amountToNumber(
            fields.contract_appointment_bill_price
          );
        }
        if (fields.project_estimate_bill_price) {
          fields.project_estimate_bill_price = amountToNumber(
            fields.project_estimate_bill_price
          );
        }
        if (fields.actual_bill_price) {
          fields.actual_bill_price = amountToNumber(fields.actual_bill_price);
        }
        this.required1 = !!fields.contract_appointment_bill_date;
        this.required2 = !!(fields.project_estimate_bill_date && fields.project_estimate_bill_date !== 'Invalid date');
        this.required3 = !!(fields.actual_bill_date && fields.actual_bill_date !== 'Invalid date');
        this.isVisiblePayment = true;
        this.editData = fields;
        this.formCache.project_estimate_bill_date = fields.project_estimate_bill_date;
        this.formCache.actual_bill_date = fields.actual_bill_date;
      } else if (e.cardTitle === '未开票预测') {
        const fields = _.cloneDeep(e.record);
        fields.contract_estimate_income_date = moment(
          fields.contract_estimate_income_date
        );
        if (fields.contract_estimate_income_price) {
          fields.contract_estimate_income_price = amountToNumber(
            fields.contract_estimate_income_price
          );
        }
        this.getPaymentNoList();
        this.isVisibleForecast = true;
        this.editData = fields;
      }
    },
    getPaymentNoList() {
      this.optionLoading = true;
      return getPeriodList({
        contract_sn: this.basicInfo.contract_sn,
      }).then((res) => {
        if (res.status === 'success') {
          this.paymentNoList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      }).finally(() => {
        this.optionLoading = false;
      });
    },
    onAddPayment() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            edit: 0,
            contract_type: this.basicInfo.contract_type,
            contract_sn: this.basicInfo.contract_sn
          };
          params.payment_data = _.clone(values);
          params.payment_data.id = this.editData.id;
          if (params.payment_data.project_estimate_bill_date) {
            params.payment_data.project_estimate_bill_date = moment(
              params.payment_data.project_estimate_bill_date
            ).format('YYYY-MM-DD');
          }
          if (params.payment_data.actual_bill_date) {
            params.payment_data.actual_bill_date = moment(
              params.payment_data.actual_bill_date
            ).format('YYYY-MM-DD');
          }
          params.payment_data.actual_bill_price === undefined && (params.payment_data.actual_bill_price = null);
          params.payment_data.project_estimate_bill_price === undefined && (params.payment_data.project_estimate_bill_price = null);
          params.payment_data.contract_appointment_bill_price === undefined && (params.payment_data.contract_appointment_bill_price = null);

          if (this.isEdit) {
            params.edit = 1;
          }
          delete params.payment_data.payment_no;
          params.payment_data = [params.payment_data];
          this.addPayment(params);
        }
      });
    },
    onAddForecast() {
      this.formForecast.validateFields((err, values) => {
        if (!err) {
          const params = {
            edit: 0,
            contract_type: this.basicInfo.contract_type,
            contract_sn: this.basicInfo.contract_sn
          };
          params.income_data = _.clone(values);
          params.income_data.id = this.editData.id;
          if (params.income_data.contract_estimate_income_date) {
            params.income_data.contract_estimate_income_date = moment(
              params.income_data.contract_estimate_income_date
            ).format('YYYY-MM-DD');
          }

          if (this.isEdit) {
            params.edit = 1;
          }
          params.income_data.income_no = 0;
          params.income_data = [params.income_data];
          this.addIncome(params);
        }
      });
    },
    onSave() {
      // const index = this.basicInfo.step_num_list.indexOf(6);
      // let next_step = 6;
      // if (index !== this.basicInfo.step_num_list.length - 1) {
      //   next_step = this.basicInfo.step_num_list[index + 1];
      // }
      addOrUpdContractPayment({
        contract_type: this.basicInfo.contract_type,
        contract_sn: this.basicInfo.contract_sn,
        edit: 0,
        payment_data: []
      }).then((res) => {
        if (res.status === 'success') {
          this.$emit('change-step', {
            curr_step_num: this.stepInfo.stepNum,
            next_step: this.stepInfo.nextStepNum
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    setSelectValue(e) {
      this.form.setFieldsValue({
        period: e
      });
    },
    setFieldsValue(e) {
      const { value } = e.target;
      this.form.setFieldsValue({
        contract_appointment_bill_date: value
      });
      this.required1 = !!value;
      this.setTriggerRule('contract_appointment_bill_price');
    },
    setFieldsValue1(e) {
      const value = moment(e).format('YYYY-MM-DD');
      this.form.setFieldsValue({
        project_estimate_bill_date:
          value && value !== 'Invalid date' ? value : undefined
      });
      (this.formCache.project_estimate_bill_date = value && value !== 'Invalid date' ? value : undefined),
      (this.required2 = !!(value && value !== 'Invalid date'));
      this.setTriggerRule('project_estimate_bill_price');
    },
    setFieldsValue2(e) {
      const value = moment(e).format('YYYY-MM-DD');
      this.form.setFieldsValue({
        actual_bill_date: value && value !== 'Invalid date' ? value : undefined
      });
      (this.formCache.actual_bill_date = value && value !== 'Invalid date' ? value : undefined),
      (this.required3 = !!(value && value !== 'Invalid date'));
      this.setTriggerRule('actual_bill_price');
    },
    setTriggerRule(targetInput) {
      this.$nextTick(() => {
        this.form.validateFields([targetInput], {
          force: true
        });
      });
    },
    getOverdueDays(start, end) {
      let gap = 0;
      if (start && end) {
        const startday = moment(start);
        const endday = moment(end);
        gap = (endday.diff(startday, 'minute') / 24 / 60).toFixed(0);
      }
      return gap;
    }
  },
  computed: {
    overdue_days() {
      return this.getOverdueDays(
        this.formCache.project_estimate_bill_date,
        this.formCache.actual_bill_date
      );
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formForecast = this.$form.createForm(this);
  },
  data() {
    const paymentColumns = [
      {
        title: '期数',
        dataIndex: 'period'
      },
      {
        title: '期款ID',
        dataIndex: 'payment_no'
      },
      {
        title: '合同约定开票日期',
        dataIndex: 'contract_appointment_bill_date'
      },
      {
        title: '比例',
        dataIndex: 'rate'
      },
      {
        title: '合同约定开票金额',
        dataIndex: 'contract_appointment_bill_price'
      },
      {
        title: '项目计划开票日期',
        dataIndex: 'project_estimate_bill_date'
      },
      {
        title: '项目计划开票金额',
        dataIndex: 'project_estimate_bill_price'
      },
      {
        title: '实际开票日期',
        dataIndex: 'actual_bill_date'
      },
      {
        title: '实际开票金额',
        dataIndex: 'actual_bill_price'
      },
      {
        title: '逾期天数',
        dataIndex: 'Overdue_days'
      },
      {
        title: '预计回款日期',
        dataIndex: 'estimate_payment_date'
      },
      {
        title: '期款情况备注',
        dataIndex: 'payment_remark'
      },
      {
        title: '操作',
        dataIndex: 'handle',
        fixed: 'right',
        align: 'center',
        width: 88,
        scopedSlots: { customRender: 'operation' }
      }
    ];
    const incomeColumns = [
      {
        title: '期数',
        dataIndex: 'period'
      },
      {
        title: '期款ID',
        dataIndex: 'payment_index'
      },
      {
        title: '未开票预测日期',
        dataIndex: 'contract_estimate_income_date'
      },
      {
        title: '未开票预测金额（含税）',
        dataIndex: 'contract_estimate_income_price'
      },
      {
        title: '更新时间',
        dataIndex: 'update_time'
      },
      {
        title: '未开票预测备注',
        dataIndex: 'income_remark'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        align: 'center',
        width: 88,
        scopedSlots: { customRender: 'operation' }
      }
    ];
    if (!this.canEdit) {
      paymentColumns.pop();
      incomeColumns.pop();
    }
    return {
      btnText: {
        cancelText: '取消',
        okText: '保存'
      },
      noList: 10,
      optionLoading: false,
      periodList: ['1期', '2期', '3期', '4期', '5期', '6期', '7期', '8期', '9期', '10期', '11期', '12期', '13期', '14期', '15期', '16期', '17期', '18期', '19期', '20期'],
      paymentNoList: [],
      submitLoading: false,
      step_num: 0,
      isVisiblePayment: false,
      isVisibleForecast: false,
      isEdit: false,
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 12 }
      },
      editData: {},
      formCache: {
        project_estimate_bill_date: null,
        actual_bill_date: null
      },
      required1: false,
      required2: false,
      required3: false,
      layout: [
        {
          cardTitle: '期款情况',
          hasStatistical: false,
          addText: '新增期款',
          hasAdd: true,
          tableColumns: paymentColumns,
          tableData: [],
          loading: false,
          needCardTitle: true
        },
        {
          cardTitle: '未开票预测',
          hasStatistical: true,
          hasAdd: true,
          addText: '新增预测',
          statisticalList: [
            {
              statisticalLabel: '未开票金额（含税）',
              val: '0',
              isPercent: false
            },
            {
              statisticalLabel: '未开票预测金额之和（含税）',
              val: '0',
              isPercent: false,
              isHighLight: false
            }
          ],
          tableColumns: incomeColumns,
          tableData: [],
          loading: false,
          needCardTitle: true
        }
      ]
    };
  }
};
</script>

<style lang="less">
</style>
